import { Card } from "../../../components/ui/card";
import { Badge } from "../../../components/ui/badge";
import numerologistPortrait from "../../../assets/images/life-journey/numerologist-portrait.jpg";

export const ExpertSection = () => {
  const achievements = [
    { number: "10+", text: "years into the Logical Science of Astrology, Numerology and Vastu Science" },
    { number: "5000+", text: "TV shows in the early 2000s" },
    { number: "40000+", text: "clients in India as well as overseas in 12 countries" },
    { number: "45000+", text: "people trained including students, entrepreneurs, professionals, housewives, people in jobs, etc." }
  ];

  return (
    <section className="bg-gradient-to-b from-background to-cosmic-blue/10">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-sm uppercase tracking-wider text-cosmic-gold mb-4">ABOUT THE MAESTRO</h2>
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Image */}
          <div className="relative">
            <div className="relative z-10">
              <img loading="lazy"
                src={numerologistPortrait}
                alt="Acharya Luvbhushan"
                className="w-full max-w-md mx-auto rounded-2xl shadow-[0_0_40px_hsl(var(--mystic-gold)/0.3)]"
              />
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-8 -right-8 w-32 h-32 bg-gradient-to-br from-cosmic-gold/20 to-cosmic-glow/20 rounded-full blur-xl"></div>
            <div className="absolute -bottom-8 -left-8 w-24 h-24 bg-gradient-to-br from-cosmic-blue/20 to-cosmic-blue-light/20 rounded-full blur-xl"></div>
          </div>

          {/* Right Column - Content */}
          <div className="space-y-8">
            <div>
              <h3 className="text-xl text-muted-foreground mb-2">This Report</h3>
              <p className="text-lg text-foreground mb-4">
                was made under the guidance of India's Leading Astrologist,
              </p>
              <h2 className="text-4xl lg:text-5xl font-bold text-cosmic-gold mb-6">
                Acharya Luvbhushan
              </h2>
              <p className="text-lg text-muted-foreground">
                Acharya Luvbhushan is India's leading expert in Astrology, Numerology and Vastu Science, known for his pioneering work in these fields.
              </p>
            </div>

            {/* Achievements */}
            <div className="space-y-4">
              {achievements.map((achievement, index) => (
                <Card key={index} className="p-4 border-cosmic-gold/20 bg-card/30 backdrop-blur-sm">
                  <div className="flex items-center space-x-4">
                    <Badge className="bg-gradient-to-r from-cosmic-gold to-cosmic-gold-dark text-primary-foreground font-bold text-lg px-4 py-2 rounded-lg">
                      {achievement.number}
                    </Badge>
                    <p className="text-foreground font-medium">
                      {achievement.text}
                    </p>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};